import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
declare const RmPaymentEngine: any;
declare global {
  interface Window {
    RmPaymentEngine: any;
  }
}

@Injectable({ providedIn: 'root' })
export class FinanceService {
  baseUrl: string = environment.API_SERVER;
  fiananceUrl: string = environment.FINANCE_API_SERVER;
  payment: any;
  constructor(private _http: HttpClient) {}

  getInvoices(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/invoice/customer/invoices/`,
      {
        params: payload.params,
      }
    );
  }

  getInvoiceDetail(payload) {
    return this._http.get(`${this.baseUrl}/finance/invoice/by/number/`, {
      params: payload.params,
    });
  }

  getPaymentTransactionDetail(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/payment/view_payment_transaction_details/${payload.gatewayTransactionRefId}/`
    );
  }

  getInvoiceDetailsWithInvoiceNumber(payload): Observable<any> {
    return this._http.get(
      `${this.baseUrl}/finance/invoice/by/number/?invoiceNumber=${payload.invoiceNumber}`
    );
  }

  uploadProofOfPayment(payload) {
    return this._http.post(
      `${this.baseUrl}/finance/payment/upload_proof_of_payment/`,
      payload.body
    );
  }

  getInvoicePayment(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/payment/for-full-invoiced/`,
      {
        params: payload.params,
      }
    );
  }
  getPayments(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/payment/customer-payments/nullable`,
      {
        params: payload.params,
      }
    );
  }
  getArrangement(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/revenue-service/arrangement`,
      {
        params: payload.params,
      }
    );
  }
  getConsoleItem(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/revenue-service/${payload.revenueServiceId}/console-item`,
      {
        params: payload.params,
      }
    );
  }
  getCurrency(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/revenue-service/applicable-currencies/${payload.revenueServiceId}/`,
      {
        params: payload.params,
      }
    );
  }

  getCurrenciesConfig(payload) {
    return this._http.get(`${this.baseUrl}/finance/config/currencies/`, {
      params: payload.params,
    });
  }

  getCommentsById(payload) {
    return this._http.get(
      this.baseUrl +
        `/finance/comments/${payload.objectId}/?appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  makeCommentById(payload) {
    return this._http.post(
      this.baseUrl + `/finance/comments/${payload.objectId}/`,
      payload.body
    );
  }

  getPaymentReceipt(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/payment/receipt/${payload.id}`,
      {
        params: payload.params,
      }
    );
  }

  getRevenue(payload) {
    return this._http.get(`${this.baseUrl}/finance/revenue-service/`, {
      params: payload.params,
    });
  }
  getInvoiceTransactions(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/invoice/invoice-transactions/${payload.id}/`,
      {
        params: payload.params,
      }
    );
  }
  makePayment(payload) {
    return this._http.post(
      `${this.baseUrl}/finance/payment/intiate-payment/`,
      payload.body
    );
  }
  financeDashboard(payload) {
    return this._http.post(
      `${this.baseUrl}/finance/organizations/enterprise/dashboard/`,
      payload.body
    );
  }
  getPaymentStatus(payload) {
    return this._http.get(
      `${this.baseUrl}/finance/payment/public-status/${payload.id}`,
      {
        params: payload.params,
      }
    );
  }

  addDocument(payload) {
    return this._http.post(
      `${this.baseUrl}/upload-official-document/file/`,
      payload.body
    );
  }
  updateDocument(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/document/${payload.id}/`,
      payload.body
    );
  }
  removeDocument(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/document/${payload.id}/`
    );
  }

  checkSimilarEquipment(payload): Observable<any> {
    return this._http.get(
      `${this.baseUrl}/tamsy/equipments/similar_equipments/has_paid?invoiceNumber=${payload.invoiceNumber}`
    );
  }
  cancelTamsyInvoice(payload): Observable<any> {
    return this._http.get(
      `${this.baseUrl}/finance/invoice/${payload.invoiceId}/cancel/`
    );
  }
  getPaymentConfig(payload): Observable<any> {
    return this._http.get(
      `${this.baseUrl}/public/app-config/${payload.configId}`
    );
  }
  financeRemitaCallback(payload): Observable<any> {
    return this._http.get(
      `${this.fiananceUrl}/payment/remita-callback/${payload.refId}`
    );
  }
  makePayment2(
    transactionId: string,
    rrr: string,
    onSuccess: Function,
    onError: Function,
    onClose: Function
  ) {
    document.body.classList.add('no-scroll');
    var paymentEngine = RmPaymentEngine.init({
      key: 'QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=',
      processRrr: true,
      transactionId: transactionId,
      channel: 'CARD',
      // ,USSD,TRANSFER,PAYWITHREMITA,PHONENUMBER,BRANCH,BANK
      extendedData: {
        customFields: [
          {
            name: 'rrr',
            value: rrr,
          },
        ],
      },
      onSuccess: function (response) {
        onSuccess(response);
      },
      onError: function (response) {
        onError(response);
      },
      onClose: function () {
        document.body.classList.remove('no-scroll');
        document.body.classList.add('scroll');
        onClose();
      },
    });
    paymentEngine.showPaymentWidget();
  }
}
